module.exports = __webpack_public_path__ + "media/images/icon-edu-card-lightpurple-021f84957508258c10f40bd506381dd9.svg";